<template>
  <vs-dropdown vs-trigger-click class="cursor-pointer mr-4">
    <div
      class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
    >
      <span class="mr-2">{{ paginationInfo }}</span>
      <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
    </div>

    <vs-dropdown-menu>
      <vs-dropdown-item
        v-for="option in options"
        :key="option"
        @click="selectOption(option)"
      >
        <span>{{ option }}</span>
      </vs-dropdown-item>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
export default {
  name: 'PaginationItemsPerPageDropdown',
  props: {
    itemsPerPage: {
      type: Number,
      default: 50,
    },
    totalItems: {
      type: Number,
      default: 0,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    options: {
      type: Array,
      default: () => [5, 10, 25, 50],
    },
  },
  computed: {
    paginationInfo() {
      if (!this.totalItems) {
        return '0 - 0 de 0';
      }
      const start = (this.currentPage - 1) * this.itemsPerPage + 1;
      const end = Math.min(this.currentPage * this.itemsPerPage, this.totalItems);
      return `${start} - ${end} de ${this.totalItems}`;
    },
  },
  methods: {
    selectOption(option) {
      this.$emit('update:itemsPerPage', option);
    },
  },
};
</script>
